import {getUnitTypesForRecruitment} from "./getUnitTypesForRecruitment";

/**
 * Типы отрядов, доступные игроку для найма (id), с учетом ограничений фракции:
 * гномам запрещена кавалерия, великанам доступен только d20 и т.п.
 *
 * Тот же источник правды, что у тулбара найма игрока
 * (getUnitTypesForRecruitment) — боты обязаны играть по тем же правилам.
 *
 * @param {Object} player
 * @returns {string[]} id доступных типов отрядов
 */
export const getRecruitableUnitTypeIds = (player) => {
  return getUnitTypesForRecruitment(player).map((unitType) => unitType.id);
};
